import type {ReactElement} from 'react';
import {IconShape, IconSize} from '@Components/icon-v2/icon.types';
import {Icon} from '@Components/icon-v2';
import {useEventsUpsellDialog} from '@Hooks/useEventsUpsellDialog';
import styles from './event-wizard-premium-icon.module.scss';
import type {EventWizardPremiumIconProps} from '@Components/event-wizard/event-wizard-premium-icon/event-wizard-premium-icon.types';

export function EventWizardPremiumIcon({upsellType}: EventWizardPremiumIconProps): ReactElement {
  const {isUpsellDialogLoading, openUpsellDialog} = useEventsUpsellDialog();

  return (
    <Icon
      isUsedAsButton
      onClick={(): void => {
        openUpsellDialog(upsellType);
      }}
      isLoading={isUpsellDialogLoading}
      loaderClassName="spacing-m-l-1"
      className={`${styles.premiumIconColor} spacing-p-0 spacing-m-l-1`}
      icon="icon-crown"
      shape={IconShape.CIRCLE}
      size={IconSize.SIZE_ICON_16}
    />
  );
}
